import { render, staticRenderFns } from "./MobileMiniCart.vue?vue&type=template&id=1c52ab22"
import script from "./MobileMiniCart.vue?vue&type=script&lang=js"
export * from "./MobileMiniCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c52ab22')) {
      api.createRecord('1c52ab22', component.options)
    } else {
      api.reload('1c52ab22', component.options)
    }
    module.hot.accept("./MobileMiniCart.vue?vue&type=template&id=1c52ab22", function () {
      api.rerender('1c52ab22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/MobileMiniCart.vue"
export default component.exports